import {
  Card,
  CardFooter,
  CardHeader,
  CardBody,
  Heading,
  Text,
  Box,
  Button,
  Notification,
  Table,
  TableHeader,
  TableRow,
  TableCell,
  TableBody,
} from "grommet";
import React, { useState, useEffect } from "react";
import { ValidateOrder } from "../graphql/mutations";
import { API } from "aws-amplify";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
dayjs.extend(utc);
dayjs.extend(timezone);

function PaymentCard({ test, user }) {
  const [isVerified, setIsVerified] = useState(false);
  const [tester, setTester] = useState(test);
  const [validError, setValidError] = useState(false);
  const [validationCount, setValidationCount] = useState(0);

  useEffect(() => {
    if (tester.verified_by) {
      setIsVerified(true);
    }
    checkValidationCount();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleValidate = async () => {
    // get date now, convert to isoString with dayjs
    const date = dayjs().toISOString();
    console.log(date);

    // check validation count is less than item quantity
    if (validationCount < tester.item_quantity) {
      try {
        const data = await API.graphql({
          query: ValidateOrder,
          variables: {
            input: {
              paymentId: tester.paymentId,
              new_verified_value: tester.new_verified_value
                ? [
                    ...tester.new_verified_value,
                    {
                      proctor: user,
                      action: "validate",
                      timestamp: date,
                    },
                  ]
                : [
                    {
                      proctor: user,
                      action: "validate",
                      timestamp: date,
                    },
                  ],
            },
          },
        });

        console.log(data);
        setTester(data.data.updatePaidTester);
        setValidationCount((prev) => prev + 1);
      } catch (error) {
        console.log(error);
      }
    } else {
      setValidError(true);
    }
  };

  const handleInvalidate = async () => {
    // get date now, convert to isoString with dayjs
    const date = dayjs().toISOString();
    console.log(date);

    // check validation count is less than item quantity

    try {
      const data = await API.graphql({
        query: ValidateOrder,
        variables: {
          input: {
            paymentId: tester.paymentId,
            new_verified_value: tester.new_verified_value
              ? [
                  ...tester.new_verified_value,
                  {
                    proctor: user,
                    action: "invalidate",
                    timestamp: date,
                  },
                ]
              : [
                  {
                    proctor: user,
                    action: "invalidate",
                    timestamp: date,
                  },
                ],
          },
        },
      });

      console.log(data);
      setTester(data.data.updatePaidTester);
      setValidationCount((prev) => prev - 1);
    } catch (error) {
      console.log(error);
    }
  };

  function checkValidationCount() {
    let temp = 0;
    if (tester.verified_by) {
      temp = tester.verified_by.length;
    }
    if (tester.new_verified_value) {
      tester.new_verified_value.forEach((itm) => {
        if (itm.action === "validate") {
          temp++;
        } else {
          temp--;
        }
      });
    }
    setValidationCount(temp);
  }
  return (
    <>
      {validError && (
        <Notification
          status="critical"
          toast
          onClose={() => setValidError(false)}
          title="You Can't Do That!"
          message="This Order is already verified"
        />
      )}
      <Card width="xlarge" background="light-1" margin="xsmall">
        <CardHeader align="center" direction="row-responsive" justify="center">
          <Heading align="center" textAlign="center" level="3" margin="small">
            {tester.cust_name}
          </Heading>
        </CardHeader>
        <CardBody pad="medium" direction="row" gap="medium" align="start">
          <Box width={{ max: "medium" }} gap="medium" justify="center">
            <Box
              align="center"
              justify="between"
              direction="row"
              flex
              gap="medium"
            >
              <Text weight="bold">Order Number:</Text>
              <Text weight="bold">{tester.referenceId}</Text>
            </Box>
            <Box
              align="center"
              justify="between"
              direction="row"
              flex
              gap="medium"
            >
              <Text weight="bold">Order Date:</Text>
              <Text weight="bold">
                {new Date(tester.createdAt).toLocaleDateString()}
              </Text>
            </Box>
            <Box
              align="center"
              justify="between"
              direction="row"
              flex
              gap="medium"
            >
              <Text weight="bold">Item: </Text>
              <Text weight="bold">{tester.item_name}</Text>
            </Box>
            <Box
              align="center"
              justify="between"
              direction="row"
              flex
              gap="medium"
            >
              <Text weight="bold">Quantity: </Text>
              <Text weight="bold">{tester.item_quantity}</Text>
            </Box>
            <Box
              align="center"
              justify="between"
              direction="row"
              flex
              gap="medium"
            >
              <Text weight="bold">Email: </Text>
              <Text weight="bold">{tester.cust_email}</Text>
            </Box>
            <Box
              align="center"
              justify="between"
              direction="row"
              flex
              gap="medium"
            >
              <Text weight="bold">Last 4 of CC: </Text>
              <Text weight="bold">{tester.lastFour}</Text>
            </Box>
          </Box>
          <Box
            align="center"
            justify="center"
            direction="column"
            flex
            gap="medium"
          >
            <Box>
              <Text>Validation Logs</Text>
            </Box>
            <Box fill="horizontal" align="center" justify="center">
              <Table alignSelf="center">
                <TableHeader>
                  <TableRow>
                    <TableCell scope="col" border="bottom">
                      Proctor
                    </TableCell>
                    <TableCell scope="col" border="bottom">
                      Date
                    </TableCell>
                    <TableCell scope="col" border="bottom">
                      Status
                    </TableCell>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {isVerified &&
                    tester.verified_by.map((itm, idx) => (
                      <TableRow key={idx} style={{ background: "lightgray" }}>
                        <TableCell>{itm.split("@")[0]}</TableCell>
                        <TableCell>{tester.verified_at}</TableCell>
                        <TableCell>validate</TableCell>
                      </TableRow>
                    ))}
                  {tester.new_verified_value &&
                    tester.new_verified_value.length > 0 &&
                    tester.new_verified_value.map((itm, idx) => (
                      <TableRow key={idx}>
                        <TableCell>{itm.proctor.split("@")[0]}</TableCell>
                        <TableCell>
                          {dayjs(itm.timestamp)
                            .tz("America/Chicago")
                            .format("MM/DD/YYYY h:m a")}
                        </TableCell>
                        <TableCell>{itm.action}</TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
              <Text>
                validations left: {tester.item_quantity - validationCount}
              </Text>
            </Box>
          </Box>
        </CardBody>
        <CardFooter background="light-2" textAlign="center">
          <Box
            align="center"
            justify="center"
            direction="row"
            flex
            gap="medium"
            height="xxsmall"
          >
            <Button
              textAlign="center"
              onClick={() => handleValidate()}
              label="Add Validation"
            />
            {validationCount > 0 && (
              <Button
                textAlign="center"
                onClick={() => handleInvalidate()}
                label="Add Invalidation"
              />
            )}
          </Box>
        </CardFooter>
      </Card>
    </>
  );
}

export default PaymentCard;
